import { getLocale } from "../runtime";

const da_chooseyourlanguageandcountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Vælg dit sprog og land for at få den bedste shoppingoplevelse.`
};

const en_chooseyourlanguageandcountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Choose your language and country to get the best shopping experience.`
};

const es_chooseyourlanguageandcountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Elige tu idioma y país para obtener la mejor experiencia de compra.`
};

const fi_chooseyourlanguageandcountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Valitse kielesi ja maasi saadaksesi parhaan ostokokemuksen.`
};

const nb_chooseyourlanguageandcountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Velg ditt språk og land for å få den beste handleopplevelsen.`
};

const sv_chooseyourlanguageandcountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Välj ditt språk och land för att få den bästa shoppingupplevelsen.`
};

const chooseyourlanguageandcountry = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_chooseyourlanguageandcountry(inputs)
	if (locale === "en") return en_chooseyourlanguageandcountry(inputs)
	if (locale === "es") return es_chooseyourlanguageandcountry(inputs)
	if (locale === "fi") return fi_chooseyourlanguageandcountry(inputs)
	if (locale === "nb") return nb_chooseyourlanguageandcountry(inputs)
	if (locale === "sv") return sv_chooseyourlanguageandcountry(inputs)
	return "chooseYourLanguageAndCountry";
};

export { chooseyourlanguageandcountry as "chooseYourLanguageAndCountry" };